import Model from 'core/model/Model';
import { computed } from 'mobx';
import $dictionary from 'app/stores/$dictionary';

class LabelModel extends Model {
  get urlRoot() {
    return '/api/ui/labels';
  }

  get messages() {
    return {
      create: 'Label was added successfully',
      update: 'Label was edited successfully',
      destroy: `Label "${this.get('name')}" was removed successfully`
    };
  }

  get removalConfirmText() {
    return {
      title: 'Remove Label',
      text: `Are you sure you want to remove ${this.get('name')}?`
    };
  }

  @computed
  get numItems() {
    return this.get('items').length;
  }

  @computed
  get option() {
    return {
      value: this.get('id'),
      label: this.get('name'),
      bg: this.get('color'),
      color: '#ffffff'
    };
  }

  @computed
  get usage() {
    return this.get('items').reduce((acc, item) => {
      acc[item.item_type] = acc[item.item_type] ?? 0;
      acc[item.item_type] += 1;
      return acc;
    }, {});
  }

  @computed
  get isPreset() {
    return this.get('company_id').toString() === $dictionary.dictionary.templateDashboardsCID.toString();
  }

  getSortValue(field) {
    if (field === 'name') {
      return this.get('name').toLowerCase();
    }

    return super.getSortValue(field);
  }
}

export default LabelModel;
